<template>
  <div
    :class="[b(), className]"
    :style="styleSizeName"
    ref="main"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
    @dblclick="handleDblClick"
    @click="handleClick"
  >
    <div :style="styleChartName" ref="box" :class="b('box')">
      <a
        ref="text"
        :class="b('text')"
        :href="linkHref"
        :style="styleName"
        :target="linkTarget"
      >
        {{ dataChart.value }}
      </a>
      <span v-if="option.unit" :style="unitStyle">{{ option.unit }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "valueText",
  data() {
    return {
      check: "",
      date: new Date(),
      left: 0,
    };
  },
  computed: {
    unitStyle() {
      return {
        color: this.option.unitColor,
        fontSize: this.option.unitFontSize + "px",
        paddingLeft: this.option.unitGap + "px",
      };
    },
    scroll() {
      return this.validData(this.option.scroll, false);
    },
    linkHref() {
      return this.option.linkHref || "#";
    },
    linkTarget() {
      return this.option.linkTarget || "_self";
    },
    step() {
      return this.option.step || 5;
    },
    speed() {
      return this.option.speed || 100;
    },
    lineHeight() {
      return this.option.lineHeight || 40;
    },
    fontSize() {
      return this.option.fontSize || 30;
    },
    split() {
      return this.option.split;
    },
    textWidth() {
      const textLen = (this.dataChart.value || "").length;
      return textLen * this.fontSize;
    },
    styleName() {
      const {
        fontFamily = '',
      } = this.themeCfg
      return Object.assign(
        {
          width: this.scroll ? this.setPx(this.textWidth) : "auto",
          transform: "translateX(" + this.left + "px)",
          textAlign: this.option.textAlign,
          letterSpacing: this.setPx(this.split),
          textIndent: this.setPx(this.split),
          backgroundColor: this.option.backgroundColor,
          fontWeight: this.option.fontWeight || "normal",
          fontFamily: this.option.fontFamily || fontFamily,
          fontSize: this.fontSize + "px",
          lineHeight: this.lineHeight + "px",
          color: this.option.color || "#333",
        },
        this.styles
      );
    },
  },
  watch: {
    scroll() {
      this.move();
    },
    speed() {
      this.move();
    },
  },
  created() {
    setInterval(() => {
      this.date = new Date();
    }, 1000);
  },
  mounted() {
    this.move();
  },
  methods: {
    updateChart() {
      if (!this.isDataCenter) {
        return;
      }
      let { categories = [], series = [] } = this.getDimentionOption();
      series = series.map(item => {
        return {
          ...item,
          data: item.data.map(dataItem => {
            const { code } = this.prop.metrics.find(metItem => metItem.fieldName === item.name)
            return dataItem[code] || dataItem
          })
        }
      })
      let arr = series;
      let el = this.prop.metrics;
      arr.forEach((item, i) => {
        if (el[i].set) {
          if (el[i].set.type == "percent" && !isNaN(Number(item.data[0]))) {
            if (el[i].set.digits) {
              item.data[0] =
                Number(item.data[0] * 100).toFixed(el[i].set.digits) + "%";
            }
          }
        }
      });
      this.dataChart.value = arr[0].data[0];
    },
    move() {
      clearInterval(this.check);
      if (this.scroll) {
        this.check = setInterval(() => {
          if (this.left < -this.textWidth) {
            this.left = this.width;
          }
          this.left = this.left - this.step;
        }, this.speed);
      } else {
        this.left = 0;
      }
    },
  },
  props: {
    option: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
};
</script>


